<img class="header-image d-block" appWidthFromWindow [src]="prefixBucket ? ((headerObj?.image || imageUrl) | bucket) : (headerObj?.image || imageUrl)">
<div class="header-text text-light text-center w-100">
  <div class="container">
    <h1 class="title header-title" [ngStyle]="headerObj?.titleStyle">{{ headerObj?.title || pageTitle }}</h1>
  </div>
</div>
